import basicWalletIcon from "~/assets/icons/wallet_basic_png.png";
import goldWalletIcon from "~/assets/icons/wallet_gold_png.png";
import { IWalletType } from "../types";

// Google captcha keys

export const GCaptchaSiteKey = "6Lfxs3koAAAAAO85gY7YYy7f-PlMfA8ceJXoqT2M";
export const GCaptchaSecretKey = "6Lfxs3koAAAAACcrHJNhnrqhJURlRWnaVvVfDNJN";

// end of keys

// FCM keys
export const FCMVapidKey =
  "BHr8dYIi12U8F12NV2XkveOz4mcozFQxlQ2oQBmYRJo9pHPew8CaEeOXj4R-0gMlY-97MzkawYOPhYR7sMdoegk";

// Wallet types
export const WALLET_TYPE: IWalletType = {
  Basic: {
    label: "Basic wallet",
    icon: basicWalletIcon,
    themeColor: "#A569BD",
    tagColor: "#A569BD",
  },
  Goal: {
    label: "Goal wallet",
    icon: goldWalletIcon,
    themeColor: "#F1C40F",
    tagColor: "#F1C40F",
  },
};

// form validations
export const formValidate = {
  userName: {
    regex: /^[a-zA-Z0-9-_]{5,50}$/,
    message:
      "Username must contain alphanumeric characters and from 5 to 50 characters!",
  },
  password: {
    regex:
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,30}$/,
    message: "Password is invalid",
  },
};

// Query keys
export const QUERY_KEY = {
  WALLET: {
    WALLET_LIST: "wallet_list",
    WALLET_ADD: "wallet_add",
    WALLET_EDIT: "wallet_edit",
    WALLET_SHARE: "wallet_share",
    WALLET_INFO: "wallet_info",
  },
  TRANSACTION: {
    TRANSACTION_LIST: "transaction_list",
    TRANSACTION_ADD: "transaction_add",
    TRANSACTION_EDIT: "transaction_edit",
    TRANSACTION_INFO: "transaction_info",
  },
  CURRENCY: {
    CURRENCY_LIST: "currency_list",
  },
  CATEGORY: {
    CATEGORY_LIST: "category_list",
    CATEGORY_INFO: "category_info",
  },
  EVENT: {
    EVENT_LIST: "event_list",
  },
  NOTIFY: {
    NOTIFY_TOTAL: "notify_total",
    NOTIFY_LIST: "notify_list",
  },
};

// User role
export const USER_ROLE = ["Owner", "Member"];

// Category icons
export const DefaultCategory: {
  [k in string]: { name: string; icon: string };
} = {
  "679950e1-487c-430c-9d16-5032d7e30966": {
    name: "Bills and Utilities",
    icon: "./category40x40/bill.png",
  },

  "620d0d1b-8121-4700-99bd-575d19f91a6b": {
    name: "Electricity Bill",
    icon: "./category40x40/electrial_bill.png",
  },
  "ca62c202-5860-46a1-b4ce-8c566b731bc3": {
    name: "Gas Bill",
    icon: "./category40x40/gas_bill.png",
  },
  "0b39e498-e123-4dce-8762-a5a478ef52e3": {
    name: "Internet Bill",
    icon: "./category40x40/internet_bill.png",
  },
  "bd9cda50-6ef6-4284-9bbe-ef5dba8e4690": {
    name: "Phone Bill",
    icon: "./category40x40/phone_bill.png",
  },
  "3ba070aa-175f-45be-a52b-c94248b02b94": {
    name: "Rentals",
    icon: "./category40x40/rental.png",
  },
  "9942550e-bce6-45e9-be3d-a57983ebfa16": {
    name: "Television Bill",
    icon: "./category40x40/tv_bill.png",
  },
  "3888f54b-92d5-4ac3-992d-1384c0eee19f": {
    name: "Water Bill",
    icon: "./category40x40/water_bill.png",
  },

  "23e1ac25-04c7-4614-9874-77c1554649e8": {
    name: "Business",
    icon: "./category40x40/business.png",
  },
  "08bc2afe-e9ba-4f33-a878-1d0c9c18df4d": {
    name: "Education",
    icon: "./category40x40/education.png",
  },
  "15248f9f-2e53-494e-9d6a-c6a093713b67": {
    name: "Books",
    icon: "./category40x40/book.png",
  },
  "0d88e748-902f-4dea-9d20-64fa85c85fe3": {
    name: "Entertainment",
    icon: "./category40x40/entertainment.png",
  },
  "e7e3ab5d-5201-4159-80cf-e2140ea53aba": {
    name: "Games",
    icon: "./category40x40/game.png",
  },
  "bbe8bfd3-14c8-469d-ada3-315d6ee30ee1": {
    name: "Movies",
    icon: "./category40x40/movies.png",
  },
  "98ad1db0-17da-4830-8088-b31432cd3d57": {
    name: "Family",
    icon: "./category40x40/family.png",
  },
  "96950cbe-c051-4456-aaa9-efaae618a8f5": {
    name: "Children and Babies",
    icon: "./category40x40/child.png",
  },
  "a226ed8b-ea09-4e79-b774-a246e8b56a89": {
    name: "Home Improvement",
    icon: "./category40x40/home-improve.png",
  },
  "1fc41da3-3a9f-459a-94da-374c9cd25448": {
    name: "Home Services",
    icon: "./category40x40/home_service.png",
  },
  "8468f9d3-7258-41c5-8880-6757797bccbf": {
    name: "Pets",
    icon: "./category40x40/pet.png",
  },
  "2ee4a34f-4590-48a2-8e1f-262f86197327": {
    name: "Fees and Charges",
    icon: "./category40x40/fee_charge.png",
  },
  "ef7ff5b2-4553-4fc2-957c-c96a5f225f0a": {
    name: "Food and Beverage",
    icon: "./category40x40/fnb.png",
  },
  "1550bd47-3bf1-4505-bb23-30554d87f388": {
    name: "Cafe",
    icon: "./category40x40/cafe.png",
  },
  "2bb2f7d0-98fe-4c1a-939e-9cc912ddb818": {
    name: "Restaurants",
    icon: "./category40x40/restaurant.png",
  },
  "892faf37-9c4b-48ed-ba8d-40bb1764323a": {
    name: "Friends and Lover",
    icon: "./category40x40/friend_love.png",
  },
  "ffc5d468-3ff5-407f-85eb-4bf4b7d6412d": {
    name: "Diplomacy",
    icon: "./category40x40/diplomacy.png",
  },
  "bd524ea7-28b8-41ae-88f4-5affbb713354": {
    name: "Gift and Donation",
    icon: "./category40x40/gift.png",
  },
  "28a7b4e4-2517-4e24-814e-125e4dcf220f": {
    name: "Charity",
    icon: "./category40x40/charity.png",
  },
  "246ccdc4-65f0-48e0-b613-b5588996c117": {
    name: "Funeral",
    icon: "./category40x40/funeral.png",
  },
  "38fbfb8e-6a33-43ad-a75d-36a52f345037": {
    name: "Marriage",
    icon: "./category40x40/marriage.png",
  },
  "6ee7b7f1-ba70-4bc3-b3ac-23f53e241497": {
    name: "Health and Fitness",
    icon: "./category40x40/health.png",
  },
  "fda22107-ae63-4711-a431-e927a25c2ecb": {
    name: "Doctor",
    icon: "./category40x40/doctor.png",
  },
  "74deb14c-6f16-40ac-bdbf-839d5411ac40": {
    name: "Personal Care",
    icon: "./category40x40/personal.png",
  },
  "0c7063a5-df1c-4523-807e-05ea633ef870": {
    name: "Pharmacy",
    icon: "./category40x40/pharmacy.png",
  },
  "e791b605-520d-44da-be6a-de8ae6e43a0c": {
    name: "Sport",
    icon: "./category40x40/sports.png",
  },
  "69a8cabf-a2d9-4da9-b394-b2fa631e277a": {
    name: "Insurances",
    icon: "./category40x40/insurance.png",
  },
  "29bb2941-d4e7-4cc6-8ce1-60374a598463": {
    name: "Investment",
    icon: "./category40x40/investment.png",
  },
  "980005b7-2e70-4717-b681-0b7fd3afb9ee": {
    name: "Other Expense",
    icon: "./category40x40/other.png",
  },
  "5b6d4211-7de5-47d6-b1f8-6885d651781b": {
    name: "Shopping",
    icon: "./category40x40/shopping.png",
  },
  "e38fa790-1b1b-4749-a68f-daa0ab4045cc": {
    name: "Accessories",
    icon: "./category40x40/accessories.png",
  },
  "91fb24fc-5384-48f2-ba72-c57238d69481": {
    name: "Clothing",
    icon: "./category40x40/clothing.png",
  },
  "7f2c988f-eb77-4d8c-ad6b-a72982149b7f": {
    name: "Electronics",
    icon: "./category40x40/electronic.png",
  },
  "dccd65fb-bc3c-4341-8132-c366f430088d": {
    name: "Footwear",
    icon: "./category40x40/footwear.png",
  },
  "e8620729-a641-427e-bf6d-b06a30104415": {
    name: "Transportation",
    icon: "./category40x40/transpotation.png",
  },
  "2cfb06d4-a97f-440a-a263-6a0ddd601a99": {
    name: "Maintenance",
    icon: "./category40x40/maintenance.png",
  },
  "e8ca14a9-af6b-43b1-a1a9-30d23ac79012": {
    name: "Parking Fees",
    icon: "./category40x40/parking.png",
  },
  "eea4e3d5-31d5-40ba-b313-990d648dd1e9": {
    name: "Petrol",
    icon: "./category40x40/petrol.png",
  },
  "300701b9-1344-4bd1-9c7a-be378ecb5519": {
    name: "Taxi",
    icon: "./category40x40/taxi.png",
  },
  "9fadc390-c8e8-48c8-b31a-694dabcbdf10": {
    name: "Travel",
    icon: "./category40x40/travel.png",
  },
  "3ec7f62d-288d-44e4-a123-ffde92e5ec43": {
    name: "Withdrawal",
    icon: "./category40x40/withdrawal.png",
  },

  "0487ac75-5419-42e9-99c8-a2f749bb7b3d": {
    name: "Award",
    icon: "./category40x40/award.png",
  },
  "a5a4d698-1c1d-4c3c-a3a0-ec64e9d9caf1": {
    name: "Gifts",
    icon: "./category40x40/gift.png",
  },
  "43efade7-943b-4180-80a8-61126d738a7e": {
    name: "Interest Money",
    icon: "./category40x40/interest_money.png",
  },
  "b5ba9078-a698-46ff-9aa0-74c6f4440e33": {
    name: "Other Income",
    icon: "./category40x40/other.png",
  },
  "960869d1-464d-4baf-8cc8-c6936da131fa": {
    name: "Salary",
    icon: "./category40x40/salary.png",
  },
  "b6252e2d-f59e-4b66-985b-d2b0f61f16a8": {
    name: "Selling",
    icon: "./category40x40/selling.png",
  },

  "094924d9-c68b-429e-bc10-c9df550c9d38": {
    name: "Debt",
    icon: "./category40x40/debt.png",
  },
  "45b256f1-4724-4d7a-930a-69848b92fc79": {
    name: "Debt Collection",
    icon: "./category40x40/dept_collect.png",
  },

  "4c7292c6-c8d6-4df6-8a4e-13134a161bab": {
    name: "Loan",
    icon: "./category40x40/loan.png",
  },
  "fff7376d-88ce-48b2-b8d9-985cfd3bf1ab": {
    name: "Repayment",
    icon: "./category40x40/repayment.png",
  },
};
